import { useKindeAuth } from '@kinde-oss/kinde-auth-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

export function LogoutButton() {
  const { logout } = useKindeAuth();
  const { t } = useTranslation();

  return (
    <Button
      variant="ghost"
      onClick={() => logout()}
      aria-label={t('auth.logoutAriaLabel')}
      className="touch-target"
    >
      {t('auth.logout')}
    </Button>
  );
}
